import { render, staticRenderFns } from "./UserModule.vue?vue&type=template&id=d13d796e&scoped=true"
import script from "./UserModule.vue?vue&type=script&lang=js"
export * from "./UserModule.vue?vue&type=script&lang=js"
import style0 from "./UserModule.vue?vue&type=style&index=0&id=d13d796e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13d796e",
  null
  
)

export default component.exports